import { VxeUI } from 'vxe-pc-ui'

// 表格渲染器
VxeUI.renderer.add('xx', {
})
